import { useQuery } from '@tanstack/react-query';
import { graphql } from '../gql/gql';
import { useAuth0 } from '../auth/AuthProvider';
import { graphqlRequest, shouldRetryQuery } from '../utils/graphqlClient';
import { DiveInsuranceByUserIdQuery } from '../gql/graphql';

// Define the GraphQL query for fetching dive insurance details
const getDiveInsuranceQuery = graphql(/* GraphQL */ `
  query diveInsuranceByUserId($userId: String!) {
    diveInsuranceByUserId(userId: $userId) {
      insuranceId
      userId
      policyNumber
    }
  }
`);

// Custom hook for fetching dive insurance details
const useGetDiveInsurance = (userId: string, enabled = true) => {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();

  const { data, error, isLoading, refetch, isFetching } =
    useQuery<DiveInsuranceByUserIdQuery>({
      queryKey: ['diveInsurance', userId],
      queryFn: async () =>
        graphqlRequest<DiveInsuranceByUserIdQuery>(
          getDiveInsuranceQuery,
          { userId },
          enabled && isAuthenticated ? getAccessTokenSilently : undefined,
        ),
      enabled: enabled && isAuthenticated,
      retry: shouldRetryQuery,
    });

  const diveInsurance = data?.diveInsuranceByUserId;

  return {
    diveInsurance,
    isLoading,
    isError: !!error,
    error,
    refetch,
    isFetching,
  };
};

export default useGetDiveInsurance;
